import { useEffect, useRef, useState } from 'react'
import { Button as ButtonChakra, ButtonProps } from '@chakra-ui/react'
import { motion } from 'framer-motion'

const FRAME_DURATION = 1000 / 16
const HUE_ROTATION_STEP = 0.075
const MAX_ROTATION = 30

const Button = ({ children, ...btnProps }: ButtonProps) => {
  const [hueRotation, setHueRotation] = useState(0)
  const rafId = useRef(0)
  const handleHover = () => {
    window.cancelAnimationFrame(rafId.current)

    setHueRotation(0)
    let startTimestamp = Date.now()

    const frame = () => {
      const elapsed = Date.now() - startTimestamp

      if (elapsed >= FRAME_DURATION) {
        setHueRotation((hue) =>
          hue < MAX_ROTATION ? hue + HUE_ROTATION_STEP : HUE_ROTATION_STEP
        )
        startTimestamp = Date.now()
      }
      rafId.current = window.requestAnimationFrame(frame)
    }

    frame()
  }

  const handleHoverEnd = () => {
    window.cancelAnimationFrame(rafId.current)
    setHueRotation(0)
  }

  useEffect(() => {
    if (btnProps.disabled) {
      handleHoverEnd()
    }
    // cleanup
    return handleHoverEnd
  }, [btnProps.disabled])

  return (
    <ButtonChakra
      as={motion.button}
      onMouseOver={handleHover}
      onMouseOut={handleHoverEnd}
      border={'2px solid rgba(255,255,255,0.1)'}
      _focus={{ outline: 'none' }}
      _hover={{
        background: 'linear-gradient(180deg, #01fffe, #ffd871)',
        opacity: 0.8,
        boxShadow: `0px 3px 0px ${btnProps.bg}`,
        color: btnProps.bg || 'rgb(70, 126, 229)',
        filter: `hue-rotate(${hueRotation}turn)`,
        willChange: 'filter',
      }}
      _active={{
        opacity: 0.65,
      }}
      {...btnProps}
    >
      {children}
    </ButtonChakra>
  )
}

export default Button
